import { Component, inject, HostListener, ElementRef, OnInit } from '@angular/core';

import {  AppService  } from '@mavles/user';
import { DashboardApiService } from '@mavles/dashboard';
import { RouteDataService } from '@mavles/shared';
import { ContactTypes } from '@mavles/contacts';
import { APP_ROUTES } from '@mavles/shared';
import { ROUTER_DATA } from '@mavles/shared';

export enum MenuTypes {
  DASHBOARD = 'Dashboard',
  SALES = 'Sales',
  LEADS = 'Leads',
  PURCHASE = 'Purchase',
  LABOURS = 'Labours',
  MY_ACCOUNTS = 'My Accounts',
  HRM = 'HRM',
  EXPENSES = 'Expenses',
  ADMIN = 'Admin Section'
}

export interface DashboardCard {
  label: string;
  iconPath: string;
  bgColorClass: string;
  textColorClass: string;
  action: () => void;
  roles?: string[]; // Future role-based access
}

export interface MenuItem {
  type: MenuTypes;
  label: string;
  icon?: string;
  roles?: string[]; // Future role-based access
  cards: DashboardCard[];
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  protected routeData = inject(RouteDataService);
  public appService: AppService = inject(AppService);
  protected dashboardService = inject(DashboardApiService);

  routerData = ROUTER_DATA;
  appRoutes = APP_ROUTES;
  ACTIVE_MENU_TYPE!: MenuTypes;
  menuTypes = MenuTypes;
  contactTypes = ContactTypes;
  isWidgetMenuOpen = false;

  menuItems: MenuItem[] = [];

  private eRef = inject(ElementRef);

  constructor(){
      const aMenutyp = this.getStoredMenuType();
      if(aMenutyp){
        this.ACTIVE_MENU_TYPE = aMenutyp;
      }else{
        this.ACTIVE_MENU_TYPE = MenuTypes.MY_ACCOUNTS;
      }
  }

  ngOnInit() {
    this.initializeMenus();
  }

  initializeMenus() {
    this.menuItems = [
      {
        type: MenuTypes.DASHBOARD,
        label: 'Dashboard',
        icon: 'bi bi-speedometer2',
        cards: [
          { label: 'Supervisor Dashboard', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.goToSupervisorDashboard() },
          { label: 'Customer Accounts', iconPath: 'assets/media/home/meeting-interview-svgrepo-com.svg', bgColorClass: 'bg-info-subtle', textColorClass: 'text-info', action: () => this.routeData.goToCustomerAccounts() },
          { label: 'Vendor Accounts', iconPath: 'assets/media/home/contact.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.goToVendorAccounts() }
        ]
      },
      {
        type: MenuTypes.MY_ACCOUNTS,
        label: 'My Accounts',
        icon: 'bi bi-wallet2',
        cards: [
          { label: 'My Wallet', iconPath: 'assets/media/svg/payment-methods/wallet.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewMyWallets() },
          { label: 'Fund Transfer', iconPath: 'assets/media/home/atm-svgrepo-com.svg', bgColorClass: 'bg-info-subtle', textColorClass: 'text-info', action: () => this.routeData.transferWallet() },
          { label: 'New Expense', iconPath: 'assets/media/home/money-cash-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createTransaction('expense') },
          { label: 'All Expenses', iconPath: 'assets/media/home/wallet-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.allTransactions('expense') }
        ]
      },      
      {
        type: MenuTypes.SALES,
        label: 'Sales',
        icon: 'bi bi-cart-check',
        cards: [
          { label: 'New Customer', iconPath: 'assets/media/home/contact.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.newContact(this.contactTypes.Customer) },
          { label: 'All Customers', iconPath: 'assets/media/home/meeting-interview-svgrepo-com.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.viewAllContacts(this.contactTypes.Customer) },
          { label: 'New Payment', iconPath: 'assets/media/home/cash-money-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createTransaction(this.contactTypes.Customer) },
          { label: 'All Payments', iconPath: 'assets/media/home/money-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.allTransactions(this.contactTypes.Customer) },
          { label: 'New Invoice', iconPath: 'assets/media/home/invoice-file-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createOrder('invoice') },
          { label: 'All Invoices', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllOrders('invoice') },
          { label: 'New Estimate', iconPath: 'assets/media/home/invoice-file-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createOrder('estimate') },
          { label: 'All Estimates', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllOrders('estimate') }
        ]
      },
      {
        type: MenuTypes.LEADS,
        label: 'Leads',
        icon: 'bi bi-person-lines-fill',
        cards: [
          { label: 'New Lead', iconPath: 'assets/media/home/contact.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.newContact(this.contactTypes.Lead) },
          { label: 'All Leads', iconPath: 'assets/media/home/meeting-interview-svgrepo-com.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.viewAllContacts(this.contactTypes.Lead) },
          { label: 'New Estimate', iconPath: 'assets/media/home/invoice-file-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createOrder('estimate') },
          { label: 'All Estimates', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllOrders('estimate') },
          { label: 'Reminders Hub', iconPath: 'assets/media/icons/duotune/general/gen007.svg', bgColorClass: 'bg-info-subtle', textColorClass: 'text-info', action: () => this.routeData.goToRemindersHub() }
        ]
      },
      {
        type: MenuTypes.PURCHASE,
        label: 'Purchase',
        icon: 'bi bi-bag-check',
        cards: [
          { label: 'New Vendor', iconPath: 'assets/media/home/contact.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.newContact(this.contactTypes.Vendor) },
          { label: 'All Vendors', iconPath: 'assets/media/home/meeting-interview-svgrepo-com.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.viewAllContacts(this.contactTypes.Vendor) },
          { label: 'New Payment', iconPath: 'assets/media/home/cash-money-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createTransaction(this.contactTypes.Vendor) },
          { label: 'All Payments', iconPath: 'assets/media/home/money-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.allTransactions(this.contactTypes.Vendor) },
          { label: 'New Purchase', iconPath: 'assets/media/home/invoice-file-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createOrder('purchase') },
          { label: 'All Purchases', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllOrders('purchase') }
        ]
      },
      {
        type: MenuTypes.LABOURS,
        label: 'Labours',
        icon: 'bi bi-people',
        cards: [
          { label: 'New Labour Worksheet', iconPath: 'assets/media/home/engineer-worker-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.createWorksheet(this.contactTypes.LabourGroup) },
          { label: 'All Labour Worksheets', iconPath: 'assets/media/home/industrial-robot-factory-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllWorksheet(this.contactTypes.LabourGroup) },
          { label: 'New Labour', iconPath: 'assets/media/home/man-raising-hand-medium-light-skin-tone-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.newContact(this.contactTypes.Labour) },
          { label: 'All Labours', iconPath: 'assets/media/home/people-holding-hands-medium-skin-tone-medium-dark-skin-tone-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllContacts(this.contactTypes.Labour) },
          { label: 'New Labour Group', iconPath: 'assets/media/home/network-group-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.newContact(this.contactTypes.LabourGroup) },
          { label: 'All Labour Groups', iconPath: 'assets/media/home/collaboration-team-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllContacts(this.contactTypes.LabourGroup) },
          { label: 'New Payment', iconPath: 'assets/media/home/cash-money-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.createTransaction(this.contactTypes.LabourGroup) },
          { label: 'All Payments', iconPath: 'assets/media/home/money-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.allTransactions(this.contactTypes.LabourGroup) }
        ]
      },
      {
        type: MenuTypes.ADMIN,
        label: 'Admin Section',
        icon: 'bi bi-shield-lock',
        roles: ['ADMIN'],
        cards: [
          { label: 'All Wallets', iconPath: 'assets/media/svg/payment-methods/wallet.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllWallets() },
          { label: 'Fund Transfer', iconPath: 'assets/media/home/atm-svgrepo-com.svg', bgColorClass: 'bg-info-subtle', textColorClass: 'text-info', action: () => this.routeData.transferWallet() },
          { label: 'All Transactions', iconPath: 'assets/media/home/money-1.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.allTransactions('all') },
          { label: 'Create Employee', iconPath: 'assets/media/home/engineer-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.createContact(this.contactTypes.Employee) },
          { label: 'All Employees', iconPath: 'assets/media/home/engineer-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllContacts(this.contactTypes.Employee) },
          { label: 'Tag Management', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.goToManageTags() },
          { label: 'Order Accounts', iconPath: 'assets/media/svg/payment-methods/order-account-bc.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.viewAllOrderAccounts() },
          { label: 'Expense Settings', iconPath: 'assets/media/home/money-1.svg', bgColorClass: 'bg-info-subtle', textColorClass: 'text-info', action: () => this.routeData.goToManageExpenses() },
          { label: 'Category Settings', iconPath: 'assets/media/home/money-1.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.viewExpenseCategories() },
          { label: 'Order Products', iconPath: 'assets/media/home/documents-w-svgrepo-com.svg', bgColorClass: 'bg-warning-subtle', textColorClass: 'text-warning', action: () => this.routeData.routeToProduct('invoice') },
          { label: 'Closure Requests', iconPath: 'assets/media/home/document-svgrepo-com.svg', bgColorClass: 'bg-danger-subtle', textColorClass: 'text-primary', action: () => this.routeData.goToClosureRequests() },
          { label: 'Device Fleet', iconPath: 'assets/media/icons/duotune/electronics/elc002.svg', bgColorClass: 'bg-primary-subtle', textColorClass: 'text-primary', action: () => this.routeData.goToManageDevices() },
          { label: 'Reminders Hub', iconPath: 'assets/media/icons/duotune/general/gen007.svg', bgColorClass: 'bg-info-subtle', textColorClass: 'text-info', action: () => this.routeData.goToRemindersHub() }
        ]
      }
    ];
  }

  canAccess(roles?: string[]): boolean {
    if (!roles || roles.length === 0) return true;
    const userRoles = this.appService.currentUser?.roles || [];
    return roles.some((role) =>
      userRoles.some((r: any) => r.name === role || r === role)
    );
  }

  get filteredMenuItems() {
    return this.menuItems.filter((item) => {
      if (!this.canAccess(item.roles)) return false;

      // Ensure at least one card is accessible
      return item.cards.some((card) => this.canAccess(card.roles));
    });
  }

  get activeCards() {
    const activeItem = this.menuItems.find(
      (m) => m.type === this.ACTIVE_MENU_TYPE
    );
    if (!activeItem || !this.canAccess(activeItem.roles)) return [];

    return activeItem.cards.filter((card) => this.canAccess(card.roles));
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isWidgetMenuOpen = false;
    }
  }

  toggleWidgetMenu() {
    this.isWidgetMenuOpen = !this.isWidgetMenuOpen;
  }

  goTo(type:MenuTypes){
    this.ACTIVE_MENU_TYPE = type;
    this.setStoredMenuType(this.ACTIVE_MENU_TYPE);
  }


  private getStoredMenuType():MenuTypes | undefined{
    return  <MenuTypes>localStorage.getItem("ACTIVE_MENU_TYPE");
  }

  private setStoredMenuType(menuType:MenuTypes):void{
    localStorage.setItem("ACTIVE_MENU_TYPE", menuType);
  }
}


